import React from 'react';
import {Card} from "../../../../../../components/card/card.jsx";

const tabs = [
    { key: "general", label: "Informações pessoais"},
    { key: "characteristics", label: "Características"},
    { key: "addresses", label: "Endereços"},
    { key: "other-information", label: "Outras informações"},
    { key: "others", label: "Geral"},
]

const IndividualFilterTabs = ({tabSelected, setTabSelected}) => {
    return (
        <Card>
            <Card.Body>
                <div className="grid grid-cols-12 gap-4 h-56">
                    <div className="col-span-12">
                        {
                            tabs.map(({key, label}, index) => (
                                <p key={index}
                                   className={`cursor-pointer mb-0.75 last:mb-0 py-0.5 px-1.25 rounded-[3px] hover:bg-[#d3d3d3] active:bg-[#d3d3d3] ${tabSelected === key ? "bg-[#d3d3d3]" : ""}`}
                                   onClick={() => setTabSelected(key)}>
                                    {label}
                                </p>
                            ))
                        }
                    </div>
                </div>
            </Card.Body>
        </Card>
    );
};

export default IndividualFilterTabs;
